module.exports = __webpack_public_path__ + "img/audio-ok.5a3f664d.png";